
import { defineComponent, ref, onMounted } from 'vue';

import axios from 'axios';

import BasicButton from '@hems/component/src/buttons/BasicButton.vue';
import ModalContainer from '@hems/component/src/modal/ModalContainer.vue';
import { TermsService } from '@hems/service';
import { BASIC_BUTTON_COLOR_TYPE } from '@hems/util/src/constant/button';
import { TERMS_TYPE } from '@hems/util/src/constant/terms';
import { getPrivacyPolicyTerms } from '@hems/util/src/helper/termsHelper';

import type { EffectiveTermsInfo } from 'hems/terms';

export default defineComponent({
  name: 'PrivacyPolicyModal',
  components: {
    BasicButton,
    ModalContainer,
  },
  emits: ['close'],
  setup() {
    const API_BASE_URL = process.env.VUE_APP_API_URL;
    const axiosInstance = axios.create({
      baseURL: API_BASE_URL,
    });
    const termsService = new TermsService(axiosInstance);

    const termsList = ref<EffectiveTermsInfo[]>([]);
    const privacyPolicyTerms = ref<EffectiveTermsInfo>();

    const getTermsList = async () => {
      try {
        termsList.value = await termsService.getTerms(TERMS_TYPE.USER);
      } catch (e) {
        console.error(e);
      }
    };

    onMounted(async () => {
      await getTermsList();
      privacyPolicyTerms.value = getPrivacyPolicyTerms(termsList.value);
    });

    return {
      termsList,
      privacyPolicyTerms,
      BASIC_BUTTON_COLOR_TYPE,
    };
  },
});
